import { useTranslation } from "react-i18next";
import {
  Skeleton,
  SkeletonBadge,
  SkeletonGroup,
} from "@/components/Skeleton";
import { SERVICE_MODULES } from "@/config/serviceModules";

// Placeholder for the services dashboard in its own frame: the title, then one card per
// module in the same grid, with the icon tile, status badge and module name.
export default function ServicesDashboardSkeleton() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[calc(100vh-180px)] bg-[radial-gradient(circle_at_top,_rgba(27,131,84,0.12),_transparent_42%),linear-gradient(180deg,_#f8fcfa_0%,_#eef6f1_100%)] px-4 py-8 sm:px-6 lg:px-8">
      <SkeletonGroup label={t("loading")} className="mx-auto max-w-[1700px]">
        <Skeleton className="mb-6 h-8 w-72 max-w-full sm:h-9 lg:h-10" />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {SERVICE_MODULES.map((module, i) => (
            <div
              key={module.key}
              className="flex min-h-[152px] flex-col justify-between rounded-2xl border border-slate-200 bg-white p-4 shadow-[0_12px_36px_rgba(15,23,42,0.08)]"
            >
              <div className="flex items-start justify-between gap-3">
                <Skeleton className="size-12 rounded-xl" />
                <SkeletonBadge className="h-6 w-20" />
              </div>
              <div className="mt-4 space-y-2">
                <Skeleton className={`h-4 ${i % 3 === 0 ? "w-3/4" : i % 3 === 1 ? "w-2/3" : "w-4/5"}`} />
                {i % 2 === 0 && <Skeleton className="h-4 w-1/2" />}
              </div>
            </div>
          ))}
        </div>
      </SkeletonGroup>
    </div>
  );
}
